import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import get from 'lodash.get';
import styles from './RelatedItemDiscount.scss';

const RelatedItemDiscount = ({ priceUI }) => {
    const discount = get(priceUI, 'discount_percentage');
    const showNetPrice = !!get(priceUI, 'states.price_displays.show_net_price');

    return discount ? (
        <span className={showNetPrice ? styles.netPrice : styles.salePrice}>
            <FormattedMessage
                id="pdp.RelatedItemDiscount.discount"
                defaultMessage="{discount}% Off"
                values={{
                    discount,
                }}
            />
        </span>
    ) : null;
};

RelatedItemDiscount.propTypes = {
    priceUI: PropTypes.object,
};

export default RelatedItemDiscount;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/RelatedItemPrice/RelatedItemDiscount.jsx